import { render, staticRenderFns } from "./RadioboxBlank.vue?vue&type=template&id=0bb006bd"
import script from "./RadioboxBlank.vue?vue&type=script&lang=js"
export * from "./RadioboxBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports